<template>
  <div class="excel-uploader">
    <button
      type="button"
      class="button primary upload-button"
      @click="showModal"
    >
      Upload
    </button>

    <div
      class="modal upload-excel-modal"
      :class="{'is-active' : show_modal}"
    >
      <div
        class="modal-background"
        @click="resetData()"
      />
      <div class="modal-content">
        <div class="box">
          <h6>System Upload</h6>
          <!-- <p>Please make sure you have selected the right organization (on the top-left of the page) that you are planning to import to. Selected organization: <b> {{organizationName}} </b> </p> -->
          <input
            id="file-input"
            ref="upload"
            type="file"
            accept=".xls, .xlsx, .xlsm"
            class="button is-outlined file-uploader"
            @change="uploadExcel"
          >
          <p class="control has-text-right space-x-2">
            <button
              type="button"
              class="button is-white"
              @click="resetData()"
            >
              Cancel
            </button>
            <button
              type="button"
              :class="isVerifyApiLoading ? 'button primary is-loading' : 'button primary'"
              :disabled="!organization"
              @click="handleAddVerifyClick()"
            >
              Verify
            </button>
          </p>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="resetData()"
      />
    </div>

    <div
      class="modal failed-items-modal"
      :class="{'is-active' : show_failed_items_modal_verify}"
    >
      <div
        class="modal-background"
        @click="hideFailedItemsVerifyModal()"
      />
      <div class="modal-content">
        <div class="box">
          <h6>Summary</h6>
          <div>
            <p class="result">
              Created {{ messages.created.length ?? 0 }} renters
            </p>
            <p class="result">
              Updated {{ messages.updated ?? 0 }} renters
            </p>
            <p class="result">
              Deleted {{ messages.deleted ?? 0 }} renters
            </p>
            <p class="result">
              All tenants - {{ messages.rows ?? 0 }} in file
            </p>
            <hr class="dropdown-divider">
          </div>

          <template v-if="Object.keys(messages.created).length">
            <div class="border-t border-white " />

            <h6>Newly Created Renters</h6>
            <div v-for="(item, index) of messages.created" :key="index">
              {{ item.firstname }} {{ item.lastname }} [{{ item.external_id }}][{{ item.unit_number }}] - {{ pluralize(Math.abs(item.delinquency_days), 'day') }}
            </div>
          </template>

          <h6 v-if="Object.keys(failedVerifyItems).length">Failed items</h6>
          <div class="failed-items">
            <div
              v-for="(failedItemKey, idx) in Object.keys(failedVerifyItems)"
              :key="'failedItem' + idx"
              class="failed-item"
            >
              <div v-if="failedItemKey !== 'result' && failedItemKey !== 'error'">
                <div class="failed__row">
                  <span class="failed__index">{{ idx + 1 }}.</span>
                  <p class="tenant-name">
                    {{ failedItemKey }}
                  </p>
                </div>
                <p
                  class="message px-2 py-3 bg-muted-200 dark:bg-muted-900 text-red-500 dark:text-red-400"
                  v-html="failedVerifyItems[failedItemKey].join('<br >')"
                />
              </div>
            </div>
          </div>
          <div class="checkbox__container">
            <input
              id="aggrement"
              v-model="isAgree"
              class="input__checkbox"
              type="checkbox"
            >
            <label
              for="aggrement"
              class="checkbox"
            >
              Agree all terms and conditions
            </label>
          </div>
          <p
            v-if="responseError"
            class="modal__error"
          >
            <span class="error__title">Error occured:</span> {{ responseError }}
          </p>
          <p
            class="control has-text-right space-x-2"
            style="margin-top: 20px;"
          >
            <button
              type="button"
              :class="isUploadLoading ? 'button primary is-loading' : 'button primary is-outlined'"
              :disabled="!organization || !isAgree"
              @click="handleAddClick()"
            >
              Upload
            </button>
            <button
              type="button"
              class="button is-white"
              @click="hideFailedItemsVerifyModal()"
            >
              Close
            </button>
          </p>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideFailedItemsVerifyModal()"
      />
    </div>
    <div
      class="modal failed-items-modal"
      :class="{'is-active' : show_failed_items_modal}"
    >
      <div
        class="modal-background"
        @click="hideFailedItemsModal()"
      />
      <div class="modal-content">
        <div class="box">
          <h6>Import result:</h6>
          <div>
            <p class="result">
              Created {{ messages.created }} renters
            </p>
            <p class="result">
              Updated {{ messages.updated }} renters
            </p>
            <p class="result">
              Deleted {{ messages.deleted }} renters
            </p>
            <p class="result">
              All tenants - {{ messages.rows }} in file
            </p>
            <hr class="dropdown-divider">
          </div>
          <h6>Failed items</h6>
          <div class="failed-items">
            <div
              v-for="(failedItemKey, idx) in Object.keys(failedItems)"
              :key="'failedItem' + idx"
              class="failed-item"
            >
              <div v-if="failedItemKey !== 'result' && failedItemKey !== 'error'">
                <div class="failed__row">
                  <span class="failed__index">{{ idx + 1 }}.</span>
                  <p class="tenant-name">
                    {{ failedItemKey }}
                  </p>
                </div>
                <p
                  class="message"
                  v-html="failedItems[failedItemKey].join('<br >')"
                />
              </div>
            </div>
          </div>

          <p
            class="control has-text-right"
            style="margin-top: 20px;"
          >
            <button
              type="button"
              class="button is-white"
              @click="hideFailedItemsModal()"
            >
              Close
            </button>
          </p>
          <p
            v-if="responseError"
            class="modal__error"
          >
            <span class="error__title">Error occured:</span> {{ responseError }}
          </p>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideFailedItemsModal()"
      />
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import DashboardService from '../../../services/dashboard.service';
import { isExcel } from '../../../utils/validationUtils';
import { Roles } from '../../../constants';

const dashboardService = new DashboardService();
export default {
  data() {
    return {
      show_modal: false,
      show_failed_items_modal_verify: false,
      show_failed_items_modal: false,
      failedVerifyItems: {},
      failedItems: {},
      file: '',
      role: this.$store.state.user.role,
      roles: Roles,
      organizations: [],
      organization: this.$store.state.organization.uuid,
      organizationName: this.$store.state.organization.name,
      messages: {
        created: '',
        updated: '',
        deleted: '',
        rows: ''
      },
      responseError: '',
      isAgree: false,
      isUploadLoading: false,
      isVerifyApiLoading: false
    };
  },
  mounted() {
    this.organizations = this.$store.state?.organizations || [];
    this.organization = this.$store.state?.organization?.uuid;
    this.organizationName = this.$store.state?.organization?.name;
  },
  methods: {
    pluralize(count, noun, suffix = 's') {
      return `${count} ${noun}${count !== 1 ? suffix : ''}`;
    },
    uploadExcel(event) {
      const file = event.target.files[0];

      if (!isExcel(file.name)) {
        this.$root.$emit('showToast', { message: 'Failed to upload the excel file. Please choose correct format', options: { cssClass: 'is-danger', duration: 2500 } });
        this.resetData();
        return;
      }
      this.file = file;
    },
    showModal() {
      this.show_modal = true;
    },
    hideModal(failedItems = {}) {
      this.show_modal = false;
      if (!this.responseError) {
        this.show_failed_items_modal_verify = false;
        if (failedItems && Object.keys(failedItems).length) {
          this.show_failed_items_modal = true;
          this.failedItems = failedItems;
        } else {
          this.show_failed_items_modal = true;
        }
      } else {
        this.show_failed_items_modal_verify = false;
        this.show_failed_items_modal = true;
      }
    },
    hideVerifyModal(failedItems = {}) {
      this.show_modal = false;
      this.isAgree = false;
      if (failedItems && Object.keys(failedItems).length) {
        this.show_failed_items_modal_verify = true;
        this.failedVerifyItems = failedItems;
      } else {
        this.show_failed_items_modal_verify = true;
      }
    },
    hideFailedItemsModal() {
      this.show_failed_items_modal = false;
      this.failedItems = {};
      this.resetData();
    },
    hideFailedItemsVerifyModal() {
      this.show_failed_items_modal_verify = false;
      this.failedVerifyItems = {};
      this.resetData();
    },
    resetData() {
      this.show_modal = false;
      this.$refs.upload.value = '';
      this.file = '';
      this.responseError = '';
      this.failedVerifyItems = {};
      this.failedItems = {};
    },
    async handleAddVerifyClick() {
      if (!this.file) {
        this.$root.$emit('showToast', { message: 'Please choose a file before proceed', options: { cssClass: 'is-danger', duration: 5000 } });
        return;
      }
      const self = this;
      self.isVerifyApiLoading = true;
      const data = new FormData();
      data.append('file', this.file);
      let failedVerifyItems = {};

      await dashboardService.uploadFileVerify(data, this.organization)
        .then((response) => {
          const { status } = response.data;
          if (status === 'success') {
            self.isVerifyApiLoading = false;
            if (response.data?.result) {
              const {
                errors: message, created, deleted, rows, updated
              } = response.data.result;
              self.messages.created = created;
              self.messages.deleted = deleted;
              self.messages.updated = updated;
              self.messages.rows = rows;

              const failedToImport = typeof message !== 'string' && Object.keys(message).length;
              const cssClass = failedToImport ? 'is-danger' : 'is-success';
              const duration = failedToImport ? 10000 : 5000;
              const notificationMessage = failedToImport ? 'Not all items were verified' : 'Files successfully verified';
              failedVerifyItems = failedToImport ? message : {};
              self.$root.$emit('showToast', { message: notificationMessage, options: { cssClass, duration } });
              self.$events.fire('refresh');
            } else if (response.data?.message) {
              self.responseError = response.data.message;
              self.$root.$emit('showToast', { message: response.data.message, options: { cssClass: 'is-danger', duration: 10000 } });
            }
          } else {
            self.isVerifyApiLoading = false;
            self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          }
          self.hideVerifyModal(failedVerifyItems);
        })
        .catch(() => {
          self.isVerifyApiLoading = false;
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    async handleAddClick() {
      if (!this.file) {
        this.$root.$emit('showToast', { message: 'Please choose a file before proceed', options: { cssClass: 'is-danger', duration: 5000 } });
        return;
      }
      this.isUploadLoading = true;

      try {
        const data = new FormData();
        data.append('file', this.file);
        // @todo refactor
        const { data: blob } = await this.customFetch(
          `${this.$store.state.API_URL}import/new/${this.organization}`,
          data,
          { responseType: 'blob' }
        );

        const preparedUrl = window.URL.createObjectURL(blob);
        window.open(preparedUrl, '_blank').focus();

        this.$root.$emit('showToast', { message: 'File successfully imported', options: { cssClass: 'is-success', duration: 5000 } });
      } catch (error) {
        this.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
      } finally {
        this.isUploadLoading = false;
      }
    },
    customFetch(apiUrl, httpOptions, options = {}) {
      return Axios.post(apiUrl, httpOptions, { headers: { Authorization: 'Bearer '.concat(this.$store.state.accessToken) }, ...options });
    }
  }
};
</script>
<style scoped lang="scss">
    .modal__error{
        margin-top: 15px;
        color: #ff0000;
    }
    .error__title{
        font-weight: 800;
    }
    .excel-uploader {
        .upload-excel-modal {
            .modal-content {
                .file-uploader {
                    margin-top: 15px;
                }
                .control {
                    margin-top: 15px;
                }
            }
        }
        .failed__row{
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;
        }
        .checkbox__container{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 20px;
        }
        .checkbox__container .checkbox{
            margin-right: 10px;
            font-weight: 700;
        }
        .input__checkbox{
            margin-right: 10px;
        }
        .failed-items-modal {
            .failed-items {
                .failed-item {
                    margin-top: 25px;

                    .tenant-name {
                        font-weight: bold;
                        font-size: 18px;
                        margin-left: 20px;
                    }
                }
            }
        }
    }
</style>
